<style scoped>
  .management-plans-actions-link {
    font-weight: bold;
  }
  .management-plans-actions-row {
    font-size: 0.85em;
    padding-right: 0px;
    text-align: right;
  }
  .management-plans-button {
    padding-top: 2px;
    padding-right: 10px;
    padding-bottom: 2px;
    padding-left: 10px;
  }
  .management-plans-button-container {
    margin-right: 20px;
    padding-bottom: 10px;
    text-align: right;
  }
  .management-plans-card {
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .management-plans-dialog-yes {
    background-color: #3F6E75;
  }
  .management-plans-details-row {
    font-size: 0.85em;
  }
  .management-plans-dialog-no {
    background-color: #863A21;
  }
  .management-plans-header-row {
    font-weight: bold;
    padding-left: 0px;
  }
  .management-plans-section-wrapper {
    padding-bottom: 10px;
  }
</style>
<!-- eslint-disable max-len -->
<template>
  <div class='view-contents'>
    <b-alert
      variant="danger"
      :show="currentSiteNotFound"
    >
      Site could not be found.
    </b-alert>
    <b-alert
      :show="successDismissCountDown"
      dismissible
      variant="success"
      @dismissed="successDismissCountDown=0"
      @dismiss-count-down="successCountDownChanged"
    >
      Management Plan submitted successfully.
    </b-alert>
    <div class="row title-row">
      <div class="col section-title">
        <span v-if="config && currentSite">
          <span>Site:&nbsp;</span>
          <a target="insightly" :href="`${config.insightly.siteUrl}${currentSite.Id}`">{{ currentSite.RecordName }}</a>
        </span>
      </div>
    </div>
    <div>
    <div class="section-header">
      <div class="col left-col"></div>
      <div class="col right-col">
        <ul class="nav nav-pills justify-content-end">
          <li v-if="currentSite" class="nav-item">
            <router-link class="nav-link rounded-pill" :to="{ name: 'Site', params: { id: currentSite.Id } }">
              <span>Site Overview</span>
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link active rounded-pill" href="#">
              <span>Management Plans</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled rounded-pill" href="#" tabindex="-1" aria-disabled="true">
              <span>Projects</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row justify-content-between management-plans-section-wrapper">
      <div class="col-4">
        <span class='section-title'>Management Plans</span>
      </div>
      <div class="col-4  management-plans-button-container">
        <b-button class='management-plans-button' pill size="sm" variant="primary" @click='createNewPlan' :disabled='!hasApprovedSiteAssessment'>
          <span>Create New Plan</span>
        </b-button>
        <div v-if='this.currentSite'>
          <b-modal id="createNewPlanModal" title="Confirm Create New Plan" @ok="createNewPlanOK">
            <p>
              <span>{{currentSite.RecordName}} doesn't have an approved Site Assessment, and therefore cannot be included in the Management Plan selection.</span>
            </p>
            <template v-slot:modal-footer="{ ok }">
              <b-button size="sm" variant="success" @click="ok" class='management-plans-dialog-yes'>Ok</b-button>
            </template>
          </b-modal>
        </div>
      </div>
      <div v-if="!managementPlans || managementPlans.length == 0" class="col-12">
        <div class="card managmement-plans-card">
          <div class="card-body">There are no Management Plans associated to this Site.</div>
        </div>
      </div>
      <div v-if="managementPlans && managementPlans.length > 0" class="col-12">
        <b-overlay :show="isDownloading">
        <div v-for="managementPlan in managementPlans" :key="managementPlan.id" class="card management-plans-card">
          <div class="card-body">
            <div class="row justify-content-between">
              <div class="col-6 management-plans-header-row">
                <span v-on:click="routeToManagementPlanForm(managementPlan.id)">
                  <a href="#">{{managementPlan.basic.planName}}</a>
                </span>
              </div>
              <div class="col-6 management-plans-actions-row">
                <span class='management-plans-actions-link' v-b-modal="'deleteManagementPlanModal'" v-on:click="setDeleteManagementPlanId(managementPlan.id)">
                  <a href="#">Delete</a>
                </span>
                <span>&nbsp;|&nbsp;</span>
                <span v-if="managementPlan.planType === 'Agricultural Management Plan'" class='management-plans-actions-link'>
                  <b-link @click="downloadManagementPlanReport(managementPlan.id, 'AgricultureReport')"><b-icon icon='download' class='download-icon'/>Download Plan</b-link>
                </span>
                <span v-else class='management-plans-actions-link'>
                  <b-link @click="downloadManagementPlanReport(managementPlan.id, 'ForestReport')"><b-icon icon='download' class='download-icon'/>Download Plan</b-link>
                </span>
                <span>&nbsp;|&nbsp;</span>
                <span class='management-plans-actions-link' v-on:click="routeToManagementPlanForm(managementPlan.id)">
                  <a href="#">Edit Plan</a>
                </span>
              </div>
            </div>
            <div class="row management-plans-details-row">
              <span class="details-label">Type: </span>
              <span>{{managementPlan.planType}}</span>
            </div>
            <div class="row management-plans-details-row">
              <span class="details-label">Prepared: </span>
              <span>{{moment(String(managementPlan.basic.planMonthYear)).format('MMMM YYYY')}}</span>
            </div>
            <div class="row management-plans-details-row">
              <span class="details-label">By: </span>
              <span>{{managementPlan.basic.author}}</span>
            </div>
          </div>
        </div>
        <b-modal id="deleteManagementPlanModal" title="Confirm Management Plan Delete" @ok="deleteManagementPlan()">
          <div>Are you sure you want to delete this Management Plan</div>
          <div>and all of its associated information?</div>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="danger" @click="cancel" class='management-plans-dialog-no'>No</b-button>
            <b-button size="sm" variant="success" @click="ok" class='management-plans-dialog-yes'>Yes</b-button>
          </template>
        </b-modal>
        </b-overlay>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
/* eslint-disable padded-blocks */
import { mapState } from 'vuex';
import AlertManager from '@/mixins/AlertManager';
import api from '@/api';
import moment from 'moment';

export default {
  name: 'ManagementPlans',
  computed: {
    ...mapState(['currentSite', 'config']),
    ...mapState('ManagementPlan', {
      managementPlans: (state) => state.managementPlans,
      managementPlanSubmitSuccess: (state) => state.submitSuccess,
    }),
    ...mapState('SiteAssessment', {
      siteAssessment: (state) => state.siteAssessment,
    }),
    hasApprovedSiteAssessment() {
      return this.siteAssessment
        && this.siteAssessment.status
        && this.siteAssessment.status === this.config.siteAssessmentForm.submitStatus.Approved;
    },
  },
  mixins: [AlertManager],
  data() {
    return {
      id: null,
      deleteManagementPlanId: null,
      moment,
      currentSiteNotFound: false,
      isDownloading: false,
    };
  },
  async mounted() {
    this.$store.dispatch('fetchSiteAsync', parseInt(this.$route.params.id, 10)).then(() => {

      if (!this.currentSite) {
        this.currentSiteNotFound = true;
      }

      this.$store.dispatch('SiteAssessment/fetchExistingSiteAssessment', parseInt(this.$route.params.id, 10)).then(() => {
        if (
          !this.siteAssessment
          || !this.siteAssessment.status
          || this.siteAssessment.status !== this.config.siteAssessmentForm.submitStatus.Approved
        ) {
          this.$bvModal.show('createNewPlanModal');
        }
      });

      this.$store.dispatch('ManagementPlan/getManagementPlansAsync', this.currentSite.Id).then(() => {
        if (this.managementPlanSubmitSuccess) {
          this.showSuccessAlert();
          this.$store.dispatch('ManagementPlan/setSubmitSuccess', false);
        }
      });

    }).catch(() => {
      this.currentSiteNotFound = true;
    });
  },
  methods: {
    createNewPlan() {
      this.$router.push({
        name: 'ManagementPlan',
      });
    },
    createNewPlanOK() {
    },
    deleteManagementPlan() {
      this.$store.dispatch(
        'ManagementPlan/deleteManagementPlan',
        { siteId: this.currentSite.Id, managementPlanId: this.deleteManagementPlanId },
      ).then(() => {
        this.deleteManagementPlanId = null;
      });
    },
    downloadManagementPlanReport(id, resource) {
      this.isDownloading = true;
      api.get(
        `report/${resource}/${id}`,
        { responseType: 'blob' },
      ).then((response) => {
        const href = window.URL.createObjectURL(
          new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
          ),
        );
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `${resource}.docx`);
        document.body.appendChild(link);
        link.click();
        this.isDownloading = false;
      }).catch((exception) => {
        this.isDownloading = false;
        console.error(exception);
      });
    },
    routeToManagementPlanForm(id) {
      this.$router.push({
        name: 'ManagementPlanForm',
        params: { id, type: 'update' },
      });
    },
    setDeleteManagementPlanId(id) {
      this.deleteManagementPlanId = id;
    },
  },
};
</script>
